import { headerContentTypeJson } from 'marketing-site/lib/httpHeaderUtils'
import { IWebinarOptions } from 'marketing-site/pages/api/webinars/tags'
import { IMarketoFormValues } from 'marketing-site/src/library/components/MarketoFormV2'
import { IWebinar } from '../../index'

export default async function createTags({ zoomType, slug }: IWebinar, values: IMarketoFormValues) {
  const tagParams: IWebinarOptions = {
    email: values.Email,
    name: values.FirstName + ' ' + values.LastName,
    webinarSlug: slug,
  }

  if (zoomType === 'meeting') {
    await fetch('/api/meetings/tags', {
      method: 'post',
      body: JSON.stringify(tagParams),
      headers: headerContentTypeJson,
    })
  } else {
    await fetch('/api/webinars/tags', {
      method: 'post',
      body: JSON.stringify(tagParams),
      headers: headerContentTypeJson,
    })
  }
}
